var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreakfast = function SvgBreakfast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16h14a1 1 0 110 2H4a1 1 0 110-2zm15-9.927c1.904.296 3 1.482 3 3.427 0 2.24-1.454 3.475-3.923 3.5a6.116 6.116 0 01-4.473 2.845 21.94 21.94 0 01-5.137.008A6.18 6.18 0 013 9.714V6a1 1 0 011-1h14a1 1 0 011 1v.073zm0 2.025v1.669c0 .395-.038.783-.11 1.16.808-.164 1.11-.608 1.11-1.427 0-.78-.275-1.22-1-1.402zM5 7v2.714a4.18 4.18 0 003.698 4.152 19.93 19.93 0 004.67-.007A4.12 4.12 0 0017 9.767V7H5z"
  })));
};
export default SvgBreakfast;